<template>
<!-- 下载中心 -->
    <div>
        <div class="headerNav">
            <div class="headerNavYinShiLogo">
                <router-link to='/homePage'><img src="../assets/img/homePage/gongsi_logo.png" alt="" /></router-link>
            </div>
            <div class="headerNavPhoneEmail">
                <div class="navPhone">
                <img src="../assets/img/homePage/dingbu_dianhua.png" alt="" />
                <span>86 (021)-36511001</span>
                </div>
                <div>
                <img src="../assets/img/homePage/dingbu_youxiang.png" class="dingbu_youxiang" alt="" />
                <span>2629387311@qq.com</span>
                </div>
            </div>
        </div>
        <div class="downloadCenter">
            <!-- 面包屑 -->
            <div class="crumbs">
                <span class="hoverColor"><router-link to='/homePage'>返回首页</router-link></span>
                <span>下载中心</span>
            </div>
            <div class="downCenter">
                <div class="container">
                    <table>
                        <thead class="thead">
                            <tr>
                                <th colspan="3">全部总共：{{count}}</th>
                            </tr>
                            <tr>
                                <th>名称</th>
                                <th>下载次数</th>
                                <th>更新时间</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="infoit in infos" :key="infoit.id">
                                <td>
                                    <a class="link_style" target="_blank" :href="infoit.url" @click="updateDownload(infoit.id)">{{infoit.sku}} <span style="color:#000;">—</span> {{infoit.productName}}</a>
                                </td>
                                <td>{{infoit.downTimes}}</td>
                                <td>{{infoit.updateTime}}</td>
                                <!-- <td>{{infoit.}}</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="pagination">
                <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="10"
                        layout="sizes, prev, pager, next"
                        :total="count">
                    </el-pagination>
                </div>
            </div>
        </div> 
        <Footer></Footer>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Footer from '@/components/Footer.vue'

// getListDownloadCenters   获取下载列表
// updateDownloadS  修改下载量
import { getListDownloadCenters,updateDownloadS} from '@/api'
export default {
    name: 'YinshiOffcialwebsiteDownloadCenter',

    data() {
        return {
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            // 总条数
            count:0,
            // 下载列表
            infos:[],
        };
    },

    mounted() {
        
    },
    components:{
        Footer,
    },
    methods: {
        ...mapMutations(['GoTop']),
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectListDownloadCenters()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectListDownloadCenters()
        },
        // 查询下载列表
        async selectListDownloadCenters(){
            let res = await getListDownloadCenters({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            if(res.code == 200){
                this.infos = res.data
                this.count = res.page.count
            }
        },
        // 修改下载量
        async updateDownload(id){
            await updateDownloadS(id);
            this.selectListDownloadCenters()
        }
    },    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
        // 查询下载列表
        this.selectListDownloadCenters()
    }
};
</script>

<style lang="scss" scoped>
// 头部 logo和电话及邮箱
    .headerNav {
        //整个div
        padding: 18px 270px;
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 999;
        background: #fff;
            //logo
        .headerNavYinShiLogo {
            img {
            width: 167px;
            height: 45px;
            }
        }
        //电话及邮箱
        .headerNavPhoneEmail {
            display: flex;
            div {
            display: flex;
            align-items: center;
            margin-top: -5px;
            img {
                width: 15px; 
                height: 15px; 
                margin-top: 8px; 
                padding: 0px 5px;
            }
            .dingbu_youxiang{
                width: 17px !important; 
            }
            span {
                height: 13px;
                font-size: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: center;
                color: #444444;
            }
            }
            .navPhone {
            margin-right: 55px;
            }
        }
    }
    .downloadCenter{
        // 面包屑
        .crumbs{
            background: #eeeeee;
            padding:10.5px 270px;
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            span:nth-child(1){
                color:#666666;
                padding:0px 11px;
                border-right:1px solid #E1E1E1;
                cursor: pointer;
                margin-left: -11px;
            }
            a{
                transition: .2s;
            }
            .hoverColor a:hover{
                color:#7492D7 !important;
            }
            span:nth-child(2){
                color:#666666;
                padding:0px 11px;
            }
        }
        // 顶部图片
        .topImg{
            height: 300px;
            background: url(../assets/img/banner_2.jpg);
        }
        // 下载中心
        .downCenter{
            padding:20px 270px;
            .container{
                margin-top: 20px;
                margin-bottom: 20px;
                /* margin: 100px;
                padding: 30px;
                transition: all ease 0.5s;
                border: 1px dashed salmon; */
            }

            table{
                font-size: 14px;
                width: 100%;
            }
            table tr{
                border-top: 1px solid #ccc;
                border-bottom: 1px solid #ccc;
                height: 50px;
            }
            table td,table th{
                padding-left: 40px;
                text-align: left;
            }
            .link_style{
                color:#1e73be ;
            }
        }
        // 分页
        .pagination{
            padding: 0px 270px 70px 270px;
            text-align: center;
        }
    }
</style>